var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.04342 10.1071L10.4373 3.70057L9.54585 2.80737L3.15198 9.21393V10.1071H4.04342ZM4.56605 11.3705H1.89111V8.69026L9.10013 1.46693C9.21836 1.34851 9.37868 1.28198 9.54585 1.28198C9.71302 1.28198 9.87335 1.34851 9.99157 1.46693L11.7751 3.25397C11.8933 3.37243 11.9597 3.53307 11.9597 3.70057C11.9597 3.86807 11.8933 4.02872 11.7751 4.14718L4.56605 11.3705ZM1.89111 12.6339H13.2389V13.8973H1.89111V12.6339Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d69b266af4eb9b57c2c03adbc713f9c1.svg";
export { ForwardRef as ReactComponent };